import React from 'react';

import TimeSlotField from '../common/fields/TimeSlotField';
import { useMasterData } from '../../contexts/MasterDataContext';

function AdditionalInfoStep({ formData, timeSlots, setTimeSlots, errors }) {
  const { subjectOptions, mediumOptions, cityOptions, classTypeOptions } = useMasterData();

  const selectedSubjects = subjectOptions.filter((s) => formData.subjects.includes(s.id));
  const selectedMediums = mediumOptions.filter((m) => formData.medium.includes(m.id));
  const selectedCities = cityOptions.filter((c) => formData.cities.includes(c.id));
  const selectedTypes = classTypeOptions.filter((t) => formData.classTypes.includes(t.id));

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <TimeSlotField
          timeSlots={timeSlots}
          setTimeSlots={setTimeSlots}
          subjects={selectedSubjects}
          medium={selectedMediums}
          cities={selectedCities}
          classTypes={selectedTypes}
          error={!!errors?.timeSlots}
          helperText={errors?.timeSlots?.[0]}
          label="Time Slots"
          required
        />
      </div>
    </div>
  );
}

export default AdditionalInfoStep;
